import {
    ChangeDetectorRef,
    Directive,
    HostBinding,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    SimpleChanges
} from '@angular/core';
import { LOGIN_SUCCESSFUL, ROUTER_NAVIGATION } from '@core/state/action-types';
import { AuthService } from '@core/state/auth/auth.service';
import { ActionsSubject } from '@ngrx/store';
import { Subject, filter, takeUntil } from 'rxjs';
import { SubscriptionLike as ISubscription } from 'rxjs';

@Directive({selector: '[ihdFeatureCheck]'})
export class FeatureCheckDirective implements OnInit, OnChanges, OnDestroy {
    @Input() featureId: string;

    @HostBinding('class.hidden') hide: boolean;

    private actionSubDestroyed$: Subject<void> = new Subject();
    private subDestroyed$: Subject<void> = new Subject();
    private subscription: ISubscription;
    private listenTo: string[];

    constructor(private authService: AuthService,
                private actionsSubject$: ActionsSubject,
                private cdr: ChangeDetectorRef) {
        // listen to the following events to show/hide the component under check
        this.listenTo = [
            // REGISTRATION_SUCCESS,
            LOGIN_SUCCESSFUL,
            // LOGIN_SWITCH_SUCCESS,
            // LOGIN_REFRESH,
            ROUTER_NAVIGATION
        ];
    }

    ngOnInit() {
        if (this.featureId) {
            this.configureActionListener();
            this.isFeatureAvailable();
        }

    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.featureId.currentValue) {
            this.isFeatureAvailable();
        }
    }

    ngOnDestroy() {
        this.subDestroyed$.next();
        this.actionSubDestroyed$.next();
        this.subscription = null;
    }

    private configureActionListener() {
        this.actionsSubject$
            .pipe(
              takeUntil(this.actionSubDestroyed$),
              filter((action) => this.listenTo.indexOf(action.type) >= 0)
            )
            .subscribe((action) => this.isFeatureAvailable());
    }

    private isFeatureAvailable() {
        if (this.subscription) {
            this.subDestroyed$.next();
            this.subscription = null;
        }

        this.subscription = this.authService.isFeatureAvailable(this.featureId)
            .pipe(takeUntil(this.subDestroyed$))
            .subscribe((isAllowed: boolean) => {
                this.hide = !isAllowed;
                this.cdr.detectChanges();
            });
    }
}
